/**
 * OfficeList JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class OfficeList
 */
class OfficeList {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // The containers for the search result indicator.
        this.listToggle    = $( '#js-officelist-listtoggle' );
        this.listContainer = $( '#js-officelist-listcontainer' );

        this.mapToggle    = $( '#js-officelist-maptoggle' );
        this.mapContainer = $( '#js-officelist-mapcontainer' );
    }

    /**
     * All events of the class.
     * @return {void}
     */
    events() {


        // Bind handlers to buttons
        $( this.listToggle ).on( 'click', ( e ) =>  {
            this.toggleList( e );
        });

        $( this.mapToggle ).on( 'click', ( e ) =>  {
            this.toggleMap( e );
        });
    }

    /**
     * This toggles the map container and hides the list container
     *
     * @param {event object} e
     */
    toggleMap( e ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        this.mapToggle.toggleClass( 'js-active' );
        this.mapContainer.toggleClass( 'js-hidden' );

        this.listToggle.removeClass( 'js-active' );
        this.listContainer.addClass( 'js-hidden' );
    }

    /**
     * This toggles the list container and hides the map container
     *
     * @param {event object} e
     */
    toggleList( e ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        this.listToggle.toggleClass( 'js-active' );
        this.listContainer.toggleClass( 'js-hidden' );

        this.mapToggle.removeClass( 'js-active' );
        this.mapContainer.addClass( 'js-hidden' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = OfficeList;



// WEBPACK FOOTER //
// ./assets/scripts/officelist.js